const VALID_KEY_LEN = 3;
const VALID_KEY_CHARS = 'abcdefghikmnopqrstuvwsyzabcdefghikmnopqrstuvwsyz123456789';

export const generateReferenceKey = (existingKeys?: string[]): string => {
  let key: string;

  // Generate key until we get a unique one (if existing
  // keys are provided)
  do {
    const items: string[] = [];
    for (let i = 0; i < VALID_KEY_LEN; i++) {
      const index = Math.floor(Math.random() * VALID_KEY_CHARS.length);
      items.push(VALID_KEY_CHARS[index]);
    }
    key = items.join('');
  } while (existingKeys && existingKeys.includes(key));

  return key;
};

export enum Medium {
  ARTICLE = 'article',
  BOOK = 'book',
  WEBPAGE = 'web_page'
}

/**
 * A reference
 */
export class Reference {
  static create(
    medium = Medium.BOOK,
    { existingKeys }: { existingKeys?: string[] } = {}
  ): Reference {
    const key = generateReferenceKey(existingKeys);
    return new Reference(key, medium, '');
  }

  public readonly key: string;
  public readonly order: number | undefined;

  public medium: Medium;
  public text: string;

  constructor(key: string, medium: Medium, text: string, order?: number) {
    this.key = key;
    this.medium = medium;
    this.text = text;

    this.order = order;
  }

  get mediumLabel(): string {
    switch (this.medium) {
      case Medium.ARTICLE:
        return 'Article';
      case Medium.BOOK:
        return 'Book';
      case Medium.WEBPAGE:
        return 'Webpage';
    }
  }

  toString(): string {
    return (
      '<Reference: ' +
      this.key +
      ', medium=' +
      this.medium +
      ", text='" +
      this.text.replace('\n', ' ') +
      "'>"
    );
  }

  toJson(): any {
    return {
      key: this.key,
      medium: this.medium as string,
      text: this.text,
      order: this.order
    };
  }

  static fromJson(json: any, order?: number): Reference {
    return new Reference(
      json.key,
      json.medium as Medium,
      json.text,
      json.order ?? order
    );
  }
}
